import { cva } from 'class-variance-authority'
import { VariantProps } from 'class-variance-authority'
import React, { HTMLAttributes, ReactNode } from 'react'

import { cn } from '@frame/lib/utils/cn'
import { PrimitiveDataAttribute } from '@frame/types'

const variants = cva('font-normal text-moss-700', {
  variants: {
    variant: {
      xxsmall: 'text-2xs',
      xsmall: 'text-xs',
      small: 'text-sm',
      default: 'text-base',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
})

type Props = {
  variant?: VariantProps<typeof variants>['variant']
  children: ReactNode
  className?: HTMLAttributes<HTMLParagraphElement>['className']
}

export function P({ variant = 'default', children, className }: Props) {
  return (
    <p data-cy={PrimitiveDataAttribute.TW_PRIMITIVE_P} className={cn(variants({ variant }), className)}>
      {children}
    </p>
  )
}
